/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SocialAnamnesisDtoEmploymentStatus =
  (typeof SocialAnamnesisDtoEmploymentStatus)[keyof typeof SocialAnamnesisDtoEmploymentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocialAnamnesisDtoEmploymentStatus = {
  UNKNOWN: 'UNKNOWN',
  EMPLOYED: 'EMPLOYED',
  SELF_EMPLOYED: 'SELF_EMPLOYED',
  STUDENT: 'STUDENT',
  UNEMPLOYED: 'UNEMPLOYED',
  IN_TRAINING: 'IN_TRAINING',
  RETIRED: 'RETIRED',
} as const;
